import { useIntl } from 'react-intl';

import FullscreenBackground from '@/components/image/FullscreenBackground';
import PlanPicker from '@/components/plans/PlanPicker';

import messages from './messages';
import { Heading, Wrapper } from './styles';

const Hero = () => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper>
			<FullscreenBackground src="/_n/images/plans/header.webp" objectPosition="bottom" />
			<Heading>{formatMessage(messages.heading)}</Heading>
			<PlanPicker />
		</Wrapper>
	);
};

export default Hero;
